import { useSelector } from 'react-redux';
import { useQueryString } from '../../../hooks/use_query_string';
import { useReferenceData } from '../../../hooks/use_reference_data';
import { getSpeciesBySpeciesName } from '../../../redux/reference_data';
import { ExtendedMapQueryParams } from './map_page_types';

export const useSpeciesSeasonGroupFilters = () => {
  const { getCurrentQuery } = useQueryString();
  const currentQuery = getCurrentQuery<ExtendedMapQueryParams>();
  const speciesBySpeciesName = useSelector(getSpeciesBySpeciesName);
  const filterSpeciesName = currentQuery.species;
  const filterSpecies = speciesBySpeciesName(filterSpeciesName);

  const { allSeasonGroups } = useReferenceData();
  const filterSeasonGroupName = currentQuery.season_group;
  const filterSeasonGroup = allSeasonGroups.find((sg) => sg.name === filterSeasonGroupName);

  return {
    filterSeasonGroup,
    filterSpecies,
  };
};
